import { render, staticRenderFns } from "./cover-select.vue?vue&type=template&id=3878c41a&scoped=true&"
import script from "./cover-select.vue?vue&type=script&lang=js&"
export * from "./cover-select.vue?vue&type=script&lang=js&"
import style0 from "./cover-select.vue?vue&type=style&index=0&id=3878c41a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3878c41a",
  null
  
)

export default component.exports